import { render, staticRenderFns } from "./ModernMenu.vue?vue&type=template&id=51da6a94&"
import script from "./ModernMenu.vue?vue&type=script&lang=js&"
export * from "./ModernMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports